export default __webpack_public_path__ + "static/media/doubleImage.65d08128.png";